
import React from "react";

interface TypingIndicatorProps {
  partnerName: string;
  partnerPhoto?: string;
}

const TypingIndicator = ({ partnerName, partnerPhoto }: TypingIndicatorProps) => {
  return (
    <div className="flex justify-start mb-2">
      <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0 mr-2">
        {partnerPhoto ? (
          <img
            src={partnerPhoto}
            alt={partnerName}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-gray-300 flex items-center justify-center">
            <span className="text-xs text-gray-600">
              {partnerName[0] || "P"}
            </span>
          </div>
        )}
      </div>
      
      <div className="bg-gray-200 rounded-2xl rounded-bl-md px-4 py-2 max-w-xs">
        <div className="flex space-x-1">
          <div className="w-2 h-2 bg-gray-500 rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-gray-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-2 h-2 bg-gray-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
